import { createContext, useContext, type ReactNode } from 'react';

import type { Config } from 'src/types';

interface ConfigProviderProps {
  config: Config;
  children: ReactNode;
}

export const ConfigContext = createContext<UseConfig | null>(null);

export const ConfigProvider = ({ children, config }: ConfigProviderProps) => (
  <ConfigContext.Provider value={{ config }}>{children}</ConfigContext.Provider>
);

interface UseConfig {
  config: Config;
}

export const useConfig = (): UseConfig => {
  const context = useContext(ConfigContext);
  if (!context) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }
  return context;
};
